function on(el = {}, eventName, callback) {
    if (el.addEventListener) {
        el.addEventListener(eventName, callback, false);
    } else if (el.attachEvent) {
        el.attachEvent(`on${eventName}`, (e) => {
            callback.call(el, e || window.event);
        });
    }
}

function off(el = {}, eventName, callback) {
    if (el.removeEventListener) {
        el.removeEventListener(eventName, callback);
    } else if (el.detachEvent) {
        el.detachEvent(`on${eventName}`, callback);
    }
}

export default {
    on,
    off,
};
